import type { SettingsUpdatePayload } from '@publicala/delfino';
import { hostBridge } from '@publicala/delfino';
import { isE2EMockActive } from '../e2eMockGuard';

/**
 * Settings API for Volpe.
 * Provides methods for settings actions via hostBridge.
 */
class SettingsAPI {
    /**
     * Update user settings in the host application.
     * @param payload - Contains settings object to update
     */
    async update(payload: SettingsUpdatePayload): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.settings.update(payload);
    }

    /**
     * Notify that cookies are disabled.
     * Skipped in E2E standalone mode to prevent errors when hostBridge is not initialized.
     */
    async cookiesAreDisabled(): Promise<void> {
        if (isE2EMockActive()) {
            return;
        }
        return hostBridge.settings.cookiesAreDisabled();
    }
}

export const settingsAPI = new SettingsAPI();
